import { render, staticRenderFns } from "./BankSelectbox.vue?vue&type=template&id=4e4aa455&"
import script from "./BankSelectbox.vue?vue&type=script&lang=js&"
export * from "./BankSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports